//types
import type { SWRConfiguration } from 'swr';
import useSWR from 'swr';

//hooks
import useUser from '@/hooks/swr/useUser';

// Utils
import { get } from '@/utils/client';

import type { PricesType } from '@/utils/hooks/swr/pricing/usePrices/types';

// Routes
import { BILLING_PRICES } from '@/routes/apiEndpoints';

const usePrices = (options?: SWRConfiguration<PricesType, Error>) => {
    const { user } = useUser();

    const {
        data,
        mutate: mutatePrices,
        error: errorPrices,
        isLoading
    } = useSWR<PricesType, Error>(
        [BILLING_PRICES, user?.id],
        ([url]) =>
            get(url).then((res: { data: PricesType }) => {
                const data = res.data;
                if ('_debugbar' in data) {
                    delete data._debugbar; //needed for local development only since debugbar isn't returned in production
                }

                return data;
            }),
        {
            shouldRetryOnError: false,
            revalidateIfStale: false,
            revalidateOnFocus: false,
            revalidateOnReconnect: false,
            ...options
        }
    );

    return {
        prices: data,
        mutatePrices,
        errorPrices,
        isLoading
    };
};
export default usePrices;
